import React from 'react';
import classNames from 'classnames';
import { Heading } from '../../components';
import { MEASURE_TYPE_LABELS, DIMENSION_UNIT_LABELS } from '../../config/configListing';
import css from './CustomExtendedDataSection.module.css';

const parseDimensions = value => {
  if (typeof value === 'string' && value.length > 0) {
    try {
      const parsed = JSON.parse(value);
      if (parsed && typeof parsed === 'object' && !Array.isArray(parsed) && parsed.entries) {
        return parsed;
      }
    } catch (_) {}
  }
  return null;
};

const SectionDimensions = props => {
  const { heading, text, headingClassName, className, rootClassName } = props;
  const data = parseDimensions(text);

  if (!data || !data.entries || data.entries.length === 0) return null;

  const { measureType, entries, notes } = data;
  const measureLabel = MEASURE_TYPE_LABELS[measureType] || measureType;
  const classes = classNames(rootClassName || css.sectionText, className);

  return (
    <section className={classes}>
      {heading ? (
        <Heading as="h2" rootClassName={css.sectionHeading} className={headingClassName}>
          {heading}
        </Heading>
      ) : null}
      <p style={{ fontSize: '12px', color: '#888', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
        {measureLabel}
      </p>
      <table style={{ borderCollapse: 'collapse', width: '100%', fontSize: '14px' }}>
        <tbody>
          {entries.map((entry, i) => (
            <tr key={i} style={{ borderBottom: '1px solid #eee' }}>
              <td style={{ padding: '6px 12px 6px 0', color: '#555', textTransform: 'capitalize' }}>
                {entry.label || '-'}
              </td>
              <td style={{ padding: '6px 0', fontWeight: '600' }}>
                {entry.value} {DIMENSION_UNIT_LABELS[entry.unit] || entry.unit}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {notes && (
        <p style={{ marginTop: '8px', fontSize: '13px', color: '#666' }}>{notes}</p>
      )}
    </section>
  );
};

export default SectionDimensions;
